"use strict";

exports.__esModule = true;
exports.default = void 0;
var _redux = require("../redux");
var _AuthProvider = require("./AuthProvider");
var _authSelectors = require("./authSelectors");
function useAuth() {
  var _useAuthentication = (0, _AuthProvider.useAuthentication)(),
    client = _useAuthentication.client;
  var status = (0, _redux.useSelector)(function (state) {
    return (0, _authSelectors.statusSelector)(state);
  });
  var error = (0, _redux.useSelector)(function (state) {
    return (0, _authSelectors.errorSelector)(state);
  });
  var session = (0, _redux.useSelector)(function (state) {
    return (0, _authSelectors.sessionSelector)(state);
  });
  var profile = (0, _redux.useSelector)(function (state) {
    return (0, _authSelectors.profileSelector)(state);
  });
  return {
    status: status,
    error: error,
    session: session,
    profile: profile,
    client: client
  };
}
var _default = exports.default = useAuth;